import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import WorkOrderStatusLayer from "../components/WorkOrderStatusLayer";

const WorkOrderStatusPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Work Order Status' />

        {/* WorkOrderStatusLayer */}
        <WorkOrderStatusLayer />
      </MasterLayout>
    </>
  );
};

export default WorkOrderStatusPage;